import { i18n } from '@lingui/core'

import type { Messages } from '@lingui/core'

import { IS_DEV } from '@/helpers/env'

if (!IS_DEV) {
  i18n.setMessagesCompiler((message) => {
    return [message]
  })
}

// 如果出现类似 https://github.com/facebook/react/issues/18178#issuecomment-595846312 的问题，
// 排查后初步怀疑是 lingui 封装的问题，暂时先不管，后续找到具体原因再处理
export function updateLocale(locale: string, translation?: Messages) {
  if (!translation) {
    // eslint-disable-next-line no-console
    console.warn(`locale: ${locale} translation is empty`)
  }
  if (locale !== i18n.locale) {
    i18n.loadAndActivate({ locale, messages: translation || {} })
  } else {
    if (!translation || Object.keys(translation).length === 0) {
      return
    }
    const previousTranslation = i18n.messages
    i18n.loadAndActivate({
      locale,
      messages: { ...previousTranslation, ...translation },
    })
  }
}
